import { getZipLocations } from '../services/locationServiceApi';

export const handleZipBlur = async ({ zipFieldId, cityFieldId, stateFieldId, token, setPopupOptions, countyFieldId }) => {
    const zipInput = document.getElementById(zipFieldId);
    const zip = zipInput?.value?.trim();

    if (!zip || zip.length < 5) return;

    const results = await getZipLocations(zip, token);
    if (results.length === 1) {
        const cityInput = document.getElementById(cityFieldId);
        const stateInput = document.getElementById(stateFieldId);
        const countyInput = countyFieldId ? document.getElementById(countyFieldId) : null;

        if (cityInput) cityInput.value = results[0].city;
        if (stateInput) stateInput.value = results[0].abbrev;
        if (countyInput && results[0].county) countyInput.value = results[0].county;

    } else if (results.length > 1) {
        // Let the caller show a city popup
        setPopupOptions({ results, cityFieldId, stateFieldId, countyFieldId });
    }

    return results;
};


export const lookupZipResults = async ({ zip, token }) => {
    if (!zip || zip.length < 5) return [];

    return await getZipLocations(zip, token);
};